import * as yup from 'yup';
import { baseRegistrationSchema } from './auth-validation';
import postalCodes from 'postal-codes-js';
import { Country } from 'country-state-city';

export const companySchema = baseRegistrationSchema.shape({});

export const companyDetailsSchema = yup.object().shape({
  companyName: yup
    .string()
    .required('Company name is required')
    .transform((value: string | null | undefined) =>
      value ? value.replace(/\s+/g, ' ').trim() : ''
    ),
  address: yup
    .string()
    .required('Address is required')
    .transform((value: string | null | undefined) =>
      value ? value.replace(/\s+/g, ' ').trim() : ''
    ),
  city: yup
    .string()
    .required('City is required')
    .transform((value: string | null | undefined) =>
      value ? value.replace(/\s+/g, ' ').trim() : ''
    ),
  state: yup
    .string()
    .required('State / Province is required')
    .transform((value: string | null | undefined) =>
      value ? value.replace(/\s+/g, ' ').trim() : ''
    ),
  country: yup
    .string()
    .required('Country is required')
    .transform((value: string | null) =>
      value ? value.replace(/\s+/g, ' ').trim() : ''
    ),
  zipCode: yup
    .string()
    .required('ZIP code is required')
    .test(
      'valid-postal-code',
      'Invalid postal code format for selected country',
      function (value) {
        const country = this.parent.country;
        if (!country || !value) return true;

        // Get country code from country name
        const countries = Country.getAllCountries();
        const countryData = countries.find(
          (c: { name: string }) => c.name === country
        );
        if (!countryData) return true;

        const countryCode = countryData.isoCode;
        const result = postalCodes.validate(countryCode, value);
        return result === true;
      }
    ),
  phone: yup
    .string()
    .matches(
      /^\+?[1-9]\d{9,14}$/,
      'Invalid phone number format. The phone number should only contain digits, start with a non-zero digit, and may optionally include a "+" for international numbers.'
    )
    .required('Phone is required'),

  contactEmail: yup
    .string()
    .email('Invalid contact email')
    .required('Contact email is required'),
  website: yup
    .string()
    .url('Invalid website URL')
    .required('Website is required'),
});
